import React, {useEffect,useState} from 'react';
import round from 'lodash/round';
import moment from 'moment-timezone';
import {useNavigate} from 'react-router-dom';
import {connect} from 'react-redux';

import useUser from '../../hooks/useUser';
import AppDashboard from '../AppDashboard';
import CalendarScreen from '../../components/calendar/CalendarScreen';
import { useGetSessionsQuery } from '../../redux/services/sessionApi';
import { useGetEventsQuery } from '../../redux/services/eventApi';
import { useGetProviderAvailabilitiesQuery } from '../../redux/services/providerAvailabilityApi';
import useIsMobile from '../../hooks/useIsMobile';
import { getStartAndEndDate } from '../../components/calendar/calendarUtils';

const ProviderCalendarPage = ({
  startHour,
  endHour,
  calendarView,
  showWeekends,
  showCancellations = false,
}) => {
  const isMobile = useIsMobile();
  const _calendarView = calendarView || (isMobile ? 'day' : 'week');
  const [date, setDate] = useState(new Date());
  const user = useUser();
  const timezone = user?.provider?.timezone || moment.tz.guess();
  useEffect(() => {
    setDate(moment().tz(timezone).toDate());
  }, [timezone]);
  const providerId = user?.provider?.id;
  const {startDate, endDate} = getStartAndEndDate({
    date, 
    calendarView: _calendarView,
    timezone,
  });
  const query = {
    provider_id: providerId,
    start_time: startDate, 
    end_time: endDate,
    limit: 100,
  };
  const sessionQuery = useGetSessionsQuery(query, {skip: !providerId});
  const sessions = sessionQuery?.data?.data || [];
  const eventsQuery = useGetEventsQuery({
    provider_id: providerId,
    start_time: startDate, 
    end_time: endDate,
  }, {skip: !providerId});
  const events = eventsQuery?.data?.data || eventsQuery?.data || [];
  const availabilityQuery = useGetProviderAvailabilitiesQuery(
    {provider_id: providerId},
    {skip: !providerId}
  );
  const availabilities = availabilityQuery?.data?.data || [];
  const metrics = !sessions || !sessions.length ? [] : [
    {
      label: 'Total Sessions', 
      value: sessions.filter(s => !s.is_canceled).length
    },
    {
      label: 'Total Care Hours', 
      value: round(sessions.filter(s => !s.is_canceled).reduce((acc, s) => acc + s.duration, 0) / 60, 1),
    },
  ];
  const childProps = {
    date,
    sessions,
    events,
    availabilities,
    metrics,
    loading: !user || sessionQuery?.isLoading,
    useSummaries: true,
    onDateChange: (e, dt) => setDate(dt),
    // onCalendarViewChange: (e, v) => setCalendarView(v),
    error: sessionQuery?.isError ? sessionQuery.error : null,
    startHour,
    endHour,
    calendarView: _calendarView,
    showCancellations,
    showWeekends,
    timezone,
    useSubtleAvailability: true,
  };
  return (
    <AppDashboard
      title='Provider Calendar'
      loading={childProps.loading} 
      error={childProps.error} 
    >
      <CalendarScreen {...childProps} />
    </AppDashboard>
  );
};

const mapState = state => ({
  ...(state?.calendarSettings || {}),
});

const mapDispatch = dispatch => ({});

export default connect(mapState, mapDispatch)(ProviderCalendarPage);